import { Component, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SearchGroup, SearchHit, SearchService } from '../../services/search.service';
import { SearchUiService } from '../../services/search-ui.service';
declare global {
  interface Window {
    dataLayer: any[];
  }
}

export {};
@Component({
  selector: 'app-global-search',
  standalone: false,
  templateUrl: './global-search.component.html',
  styleUrl: './global-search.component.css'
})
export class GlobalSearchComponent implements OnDestroy {
  @ViewChild('searchInput') searchInput?: ElementRef<HTMLInputElement>;

  abierto = false;
  query = '';
  cargando = false;
  buscado = false;
  grupos: SearchGroup[] = [];

  private query$ = new Subject<string>();
  private sub = new Subscription();

  constructor(
    private searchService: SearchService,
    private router: Router,
    private searchUi: SearchUiService
  ) {
    this.sub.add(
      this.query$
        .pipe(debounceTime(150), distinctUntilChanged())
        .subscribe((q) => this.ejecutarBusqueda(q))
    );
    this.sub.add(this.searchUi.open$.subscribe(() => this.abrir()));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    document.body.style.overflow = '';
  }

  /** Esc cierra el buscador. */
  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.abierto) this.cerrar();
  }

  abrir(): void {
    this.abierto = true;
    document.body.style.overflow = 'hidden';
    setTimeout(() => this.searchInput?.nativeElement.focus(), 0);
  }

  cerrar(): void {
    this.abierto = false;
    document.body.style.overflow = '';
  }

  onInput(): void {
    this.query$.next(this.query);
    if (!this.query.trim()) {
      this.grupos = [];
      this.buscado = false;
      this.cargando = false;
    } else {
      this.cargando = true;
    }
  }

  private async ejecutarBusqueda(q: string): Promise<void> {
    if (!q.trim()) {
      this.grupos = [];
      this.cargando = false;
      this.buscado = false;
      return;
    }
    try {
      const hits = await this.searchService.search(q);
      this.grupos = this.searchService.agrupar(hits);
      
    } catch (e) {
      console.error('Error en la búsqueda:', e);
      this.grupos = [];
    } finally {
      this.cargando = false;
      this.buscado = true;
    }
  }

  irA(hit: SearchHit): void {

    const term = this.query.trim();
      console.log('CLICK RESULTADO', hit);
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'site_search',
        search_term: term,
        selected_result: hit.titulo,
        selected_url: hit.url
      });
    

    this.cerrar();
    this.query = '';
    this.grupos = [];
    this.buscado = false;
    // Las noticias usan rutas con marca (/{marca}/...) que pueden estar fuera del
    // router de Angular: navegamos por URL para cubrir ambos casos.
    this.router.navigateByUrl(hit.url).catch(() => {
      window.location.href = hit.url;
    });
  }

  /** Devuelve el HTML resaltado de un atributo, con fallback al texto plano. */
  resaltado(hit: SearchHit, attr: 'titulo' | 'descripcion' | 'contenido'): string {
    const snippet = hit._snippetResult?.[attr]?.value;
    const highlight = hit._highlightResult?.[attr]?.value;
    return snippet || highlight || (hit as any)[attr] || '';
  }

  trackHit(_: number, hit: SearchHit): string {
    return hit.objectID;
  }
}
